<template lang="pug">
</template>
<script>
import { showDialog } from 'vant';
import { mapGetters } from 'vuex'
// 公共方法
import { getUrlParams } from '../../utils/const'
export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters(['doctorInfo', 'urlParams']),
    },
    beforeMount() {
        this.init()
        this.getUrlParams()
    },
    methods: {
        /**
         * inquiryType: 0 专家 1极速
         * inquiryStatus: 问诊状态(0:无 / 1:待派单 / 2:已派单待接诊 / 3:已接诊 / 4:接诊完成 / 5:医生取消 / 6:患者取消 / 7:超时 /)
         */
        async init() {
            const { keyID, callbackUrl } = this.$route.query
            const params = { keyID: keyID }
            const url = decodeURIComponent(callbackUrl)
            this.$store.commit('global/updateSourcePath', url)
            const res = await this.$_http.get(this.$_API.GET_INQUERY_DETAIL_INFO, { params })
            if (res.success) {
                if (res.data.serviceType) {
                    //极速
                } else {
                    //专家
                    this.$store.commit('user/updateOrderDetail', { ...res.data, orderPatientID: res.data.patientIMID })
                    this.$store.commit('global/updateInquiryInfo', res.data)
                    this.$store.commit('global/updateDoctorInfo', { ...this.doctorInfo, faceImage: res.data.doctorPhotoUrl })
                    this.$router.replace({
                        path: '/specialistWait/waiting',
                        query: {
                            keyID,
                            ...this.urlParams
                        },
                    })
                }
            }
        },
        getUrlParams () {
        if (this.$route.name === 'rpViewer') return
            let obj = getUrlParams()
            if (!obj['keyID'] || !obj['token']) {
                showDialog({
                    message: '参数缺失，请重新进入',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#438BEF',
                    closeOnClickOverlay: true
                });
            }
            this.$store.commit('global/updateUrlParams', obj)
        },  
    },
}
</script>
